import { tv } from 'tailwind-variants'

import { StatusBadge, statusBadgeVariants } from '@/components/ui'
import { PROJECT_STATUSES } from '@/modules/projects/constants'
import { humanizeText } from '@/utils'

// Statements and documents run the same pipeline, so their badges reuse this palette.
export const PROJECT_STATUS_SLOTS = {
  [PROJECT_STATUSES.notStarted]: { base: '', dot: '' },
  [PROJECT_STATUSES.processing]: {
    base: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100',
    dot: 'bg-blue-500',
    icon: 'text-blue-500',
  },
  [PROJECT_STATUSES.succeeded]: {
    base: 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-100',
    dot: 'bg-emerald-500',
  },
  [PROJECT_STATUSES.failed]: {
    base: 'bg-red-50 text-red-700 border-red-200 hover:bg-red-100',
    dot: 'bg-red-500',
  },
  [PROJECT_STATUSES.combining]: {
    base: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100',
    dot: 'bg-blue-500',
    icon: 'text-blue-500',
  },
  [PROJECT_STATUSES.duplicating]: {
    base: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100',
    dot: 'bg-blue-500',
    icon: 'text-blue-500',
  },
  [PROJECT_STATUSES.combineFailed]: {
    base: 'bg-red-50 text-red-700 border-red-200 hover:bg-red-100',
    dot: 'bg-red-500',
  },
  [PROJECT_STATUSES.duplicateFailed]: {
    base: 'bg-red-50 text-red-700 border-red-200 hover:bg-red-100',
    dot: 'bg-red-500',
  },
}

const projectStatusBadgeVariants = tv({
  extend: statusBadgeVariants,
  variants: { status: PROJECT_STATUS_SLOTS },
  defaultVariants: { status: PROJECT_STATUSES.notStarted },
})

export const PROJECT_ANIMATED_STATUSES: string[] = [
  PROJECT_STATUSES.processing,
  PROJECT_STATUSES.combining,
  PROJECT_STATUSES.duplicating,
]

interface ProjectStatusBadgeProps {
  status?: string
  className?: string
  showLabel?: boolean
}

export const ProjectStatusBadge = ({
  status = PROJECT_STATUSES.notStarted,
  className,
  showLabel,
}: ProjectStatusBadgeProps) => (
  <StatusBadge
    slots={projectStatusBadgeVariants({ status })}
    label={humanizeText(status)}
    animated={PROJECT_ANIMATED_STATUSES.includes(status)}
    className={className}
    showLabel={showLabel}
  />
)
